<ng-template #cguDialog>
  <h1 mat-dialog-title>Bienvenue sur CodeOnline GLN !</h1>
  <div mat-dialog-content style="font-weight:400" >
      <p class="gs1-little">Avant d'utiliser notre outil GS1 France, vous devez accepter nos <a target="_blank" href="/assets/files/CONDITIONS GENERALES D'UTILISATION - Outil de gestion des GLN 28072022.pdf">conditions générales d'utilisation</a> en cochant la case ci-dessous.</p>
      <gs1-checkbox [name]="'cgu'" [(ngModel)]="hasAccepted">
        <label for="cgu">J'ai lu et j'accepte les conditions générales d'utilisation. </label>
      </gs1-checkbox>
  </div>
  <div mat-dialog-actions>
      <button gs1Button [disabled]="hasAccepted !== true" [pending]="updating" [thin]="true" (click)="closeCGU()">Accepter</button>
  </div>
</ng-template>
